<template>
  <div>
    <v-row justify="center">
      <v-col cols="8">
        <div class="body-2 primaryText--text mt-12 text-center">
          <p>Well done, you are almost there.<br />
          Please keep in mind that once your application is submitted, it cannot be amended.<br />
          Therefore, kindly make sure that your application meets the requirements</p>
          <!-- <p>
            Please make sure you have submitted all the required documents.
            <br />You will receive an email confirmation as soon as your documents have been verified.
          </p>
          <p>Thank you for submitting your application and we will let all of our applicants know when we have reached a decision.</p> -->
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-12" justify="center">
      <v-col cols="6">
        <v-row justify="center">
          <v-btn
            :loading="submitting"
            class="full-width"
            @click="submitUserApplication"
            color="accent"
          >Submit Your Application Now</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AppSubmission",
  data() {
    return {
      submitting: false
    };
  },
  computed: {},
  methods: {
    ...mapActions("profile", ["submitApplication"]),

    async submitUserApplication() {

      this.submitting = true;

      try {
        await this.submitApplication();

        this.$router.replace({
          name: "applicationSubmitted"
        });

        
      }  finally {
        this.submitting = false;
      }
    }
  }
};
</script>